import { TweenLite, CSSPlugin, AttrPlugin, ScrollToPlugin  } from "gsap/all";

const plugins = [ CSSPlugin, AttrPlugin, ScrollToPlugin ];

let scroller;

if( scroller = document.querySelector('.scroll-indicator') ) {
    scroller.addEventListener('click', () => {
        TweenLite.to( window, 1, { scrollTo: window.innerHeight } )
    })
}